import React from 'react';
import './Notification.css';

export default props => {
    let cn = props.message ? "notification" : "hidden";
    return(
        <div className={cn}>
            <span>{props.message}</span>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/common/notification/Notification.js